import { __awaiter, __generator } from "tslib";
import { inlineSingleSelectKey } from '.';
import { createSelectDriver } from '../../../../primitives/selectors/drivers';
export var createInlineSingleSelectDriver = function (wrapper, className, portalTargetWrapper) {
    var base = wrapper.$("." + inlineSingleSelectKey);
    var selectDriver = createSelectDriver(base, className, portalTargetWrapper);
    var maybeCustomView = base.$('.custom-view');
    var openSelection = function () { return selectDriver.openSelection(); };
    return {
        getDisplayedText: function () { return base.text(); },
        openSelection: openSelection,
        isMenuOpen: function () { return selectDriver.isMenuOpen(); },
        selectAtIndex: function (index) { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, openSelection()];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, selectDriver.selectAtIndex(index)];
                    case 2:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); },
        selectOptionsBySelector: function (selector) { return selectDriver.selectOptionsBySelector(selector); },
        getSelectionTitles: function () { return __awaiter(void 0, void 0, void 0, function () {
            var selector;
            return __generator(this, function (_a) {
                selector = '.select-v3__option';
                return [2 /*return*/, selectDriver.base.$$(selector)
                        .map(function (e) { return e.text(); })];
            });
        }); },
        getSelectedValue: function () { return selectDriver.getSelectedValue(); },
        onHover: function () { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, maybeCustomView.exists()];
                    case 1:
                        if (_a.sent()) {
                            return [2 /*return*/, base.$('.custom-view').hover()];
                        }
                        else {
                            return [2 /*return*/, base.$('.unfocused-body').hover()];
                        }
                        return [2 /*return*/];
                }
            });
        }); },
        clickToEdit: function () { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, maybeCustomView.exists()];
                    case 1:
                        if (_a.sent()) {
                            return [2 /*return*/, base.$('.custom-view').click()];
                        }
                        else {
                            return [2 /*return*/, base.$('.unfocused-body').click()];
                        }
                        return [2 /*return*/];
                }
            });
        }); },
        showingSelect: function () { return selectDriver.base.exists(); },
        clickClear: function () { return base.$('.clear-button').click(); },
        isClearDisabled: function () { return base.$('.clear-button.disabled').exists(); },
        clickConfirm: function () { return base.$('.confirm-button').click(); },
        clickCancel: function () { return base.$('.cancel-button').click(); },
        searchItems: function (searchTerm) { return selectDriver.enterText(searchTerm); },
        getSearchInput: function () { return base.$('input').value(); },
        isRenderedValue: function () { return base.$('.inline-text-value').exists(); },
        isLoading: function () { return base.$('.tiny-loader').exists(); },
        isDisabled: function () { return base.$('.unfocused-body').hasClass('disabled'); },
        hasCancelConfirmButtons: function () { return base.$('.right-buttons').exists(); },
        base: base,
    };
};
//# sourceMappingURL=driver.js.map